import {openGet, openPost} from './openAjaxUtils';
import {deleteJson, getJson, patchJson, postJson} from '@/util/ajaxUtils';

export function getOpenComments(type = 'news', newsId, userId) {
    return openGet(`/open/comments/${newsId}`, {params: {type, userId}});
}

export function addComment(commentType = 'news', appId, newsId, userId, userName, content) {
    return openPost(`/open/comments/${newsId}`, {
        data: {
            type: commentType,
            appId,
            itemId: newsId,
            userId,
            userName,
            content,
        },
    });
}

export function replyComment(commentId, content) {
    return postJson(`/comments/reply/${commentId}`, {
        data: {
            content,
        },
    });
}

export function getCommentsUrl(appId) {
    return `/comments/list?appId=${appId}`;
}

export function getComment(appId, start, end) {
    return getJson(`/comments/list?appId=${appId}`, {params: {start, end}});
}

export function getCommentGroupByNewsUrl(appId) {
    return `/comments/list-by-news?appId=${appId}`;
}

export function getCommentGroupByNews(appId, start, end) {
    return getJson(`/comments/list-by-news?appId=${appId}`, {params: {start, end}});
}

export function getComments(appId, itemId) {
    return getJson(`/comments/list-by-item`, {params: {appId, itemId}});
}

export function toggleComment(commentId, shown, stick) {
    return patchJson(`/comments/toggle/${commentId}`, {data: {shown, stick}});
}

export function deleteComment(commentId) {
    return deleteJson(`/comments/${commentId}`);
}

export function getCommentCount(itemId) {
    return getJson(`/comments/count/${itemId}`);
}
